import { FGSelectInput, FGTextInput, useFGContext } from "nsitools-react";
import * as React from "react";
import { useQuery } from "react-query";

import { HopeViewLieuFormationDto } from "../../api";
import { useCommonHooks } from "../../hooks";
import { ETLCodes } from "../../locales";
import { nameof } from "../../utils";
import { SwitchButton } from "../applicationButtons";

export interface ILieuFormationSuggestSelectProps {
  idName: string;
  nomName: string;
  label?: string;
  isVisible?: boolean;
}

export const LieuFormationSuggestSelect: React.FunctionComponent<
  ILieuFormationSuggestSelectProps
> = ({ idName, nomName, label, isVisible }) => {
  const {
    t,
    apis: { beneficiaryCompanies },
  } = useCommonHooks();
  const { formik } = useFGContext();

  const [textMode, setTextMode] = React.useState(false);
  const [userCleared, setUserCleared] = React.useState(false);

  const idsiegeSocial = formik?.values?.idsiegeSocial;
  const siegeTextMode = !idsiegeSocial;

  const { data, isFetching } = useQuery(
    ["lieu-formation-suggest", idsiegeSocial],
    async () =>
      await beneficiaryCompanies.getBeneficiaryCompanyLieuxFormation(
        idsiegeSocial
      ),
    { enabled: !!idsiegeSocial }
  );

  // Auto-select when only 1 lieu exists
  React.useEffect(() => {
    if (data?.length === 1 && !formik?.values?.[idName] && !textMode && !userCleared) {
      formik?.setFieldValue(idName, data[0].idlieuFormation);
    }
  }, [data, idName, formik, textMode, userCleared]);

  // Reset text mode and userCleared when siege changes
  React.useEffect(() => {
    if (idsiegeSocial) {
      setTextMode(false);
      setUserCleared(false);
    }
  }, [idsiegeSocial]);

  if (!isVisible) return <></>;

  if (siegeTextMode || textMode) {
    return (
      <FGTextInput
        name={nomName}
        label={label ?? t(ETLCodes.NomLieuFormation)}
        rightElement={
          !siegeTextMode ? (
            <SwitchButton
              icon="undo"
              className=""
              onClick={() => {
                formik.setFieldValue(nomName, undefined);
                setTextMode(false);
              }}
            />
          ) : undefined
        }
      />
    );
  }

  return (
    <FGSelectInput
      name={idName}
      label={label ?? t(ETLCodes.LieuFormation)}
      items={data}
      loading={isFetching}
      displayField={nameof<HopeViewLieuFormationDto>("nom")}
      valueField={nameof<HopeViewLieuFormationDto>("idlieuFormation")}
      onChange={(value) => {
        if (!value) {
          setUserCleared(true);
        }
      }}
      rightElement={
        <SwitchButton
          icon="add"
          smaller
          onClick={() => {
            formik.setFieldValue(idName, undefined);
            setTextMode(true);
          }}
        />
      }
    />
  );
};

export default LieuFormationSuggestSelect;
